/**
 * URL pública navegable de un formulario de marketing.
 * Fuente única para el editor (pestaña Distribución) y la vista detalle (modal),
 * de modo que ambos muestren SIEMPRE el mismo enlace (inc35).
 */
export function buildPublicFormUrl(slug: string | null | undefined): string {
  if (!slug) return '';
  return `${window.location.origin}/#/f/${slug}`;
}
